// extracted by mini-css-extract-plugin
export default {"control":"TestSectionControlPanel_control__J96MP","icon_container":"TestSectionControlPanel_icon_container__dFa3C"};